import useAxios from "../Hooks/useAxios";
import styles from "./SingleChildInfo.module.css";
const SingleChildInfo = ({ data, index, handleChange }) => {
  const axios = useAxios();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const handleDelete = (id) => {
    axios
    .delete(backend_base + "/user/children/" + id)
    .then((res) => {
      if (res.status === 201 || res.status === 200) {
        console.log("Successfully Deleted Child");
        window.location.reload()
      }
    })
    .catch((e) => {
      console.log(e);
    });
  };
  
  return (
    <div className={styles.main_div}>
      <div className={styles.cross} onClick={() => handleDelete(data.id)}>X</div>
      <div className={styles.sub_div}>
        <div className={styles.single_row}>
          <div className={styles.col1}>お名前</div>
          <input
            value={data.kanjiname}
            onChange={(e) => {
              handleChange(e, index);
            }}
            name="kanjiname"
            className={styles.input_sm01}
          />
        </div>
        <div className={styles.single_row}>
          <div className={styles.col1}>ふりがな</div>
          <input
            value={data.furiganaName}
            onChange={(e) => {
              handleChange(e, index);
            }}
            name="furiganaName"
            className={styles.input_sm01}
          />
        </div>
        <div className={styles.single_row}>
          <div className={styles.col1}>性別</div>
          <div className={styles.radio_section}>
            <div className={styles.element}>
              <div className={styles.radio_button}>
                <input
                  className={styles.radio}
                  type="radio"
                  name={"sex" + index.toString()}
                  checked={data.sex === "女の子"}
                  onClick={(e) => {
                    e.target.name = "sex";
                    e.target.value = "女の子";
                    handleChange(e, index);
                  }}
                />
              </div>
              <div className={styles.radio_text}>女の子</div>
            </div>
            <div className={styles.element}>
              <div className={styles.radio_button}>
                <input
                  className={styles.radio}
                  type="radio"
                  name={"sex" + index.toString()}
                  checked={data.sex === "男の子"}
                  onClick={(e) => {
                    e.target.name = "sex";
                    e.target.value = "男の子";
                    handleChange(e, index);
                  }}
                />
              </div>
              <div className={styles.radio_text}>男の子</div>
            </div>
            <div className={styles.element}>
              <div className={styles.radio_button}>
                <input
                  className={styles.radio}
                  type="radio"
                  name={"sex" + index.toString()}
                  checked={data.sex === "未定"}
                  onClick={(e) => {
                    e.target.name = "sex";
                    e.target.value = "未定";
                    handleChange(e, index);
                  }}
                />
              </div>
              <div className={styles.radio_text}>未定</div>
            </div>
          </div>
        </div>
        <div className={styles.single_row}>
          <div className={styles.col1}>生年月日（西暦）</div>
          <div className={styles.date_section}>
            <input
              className={styles.input_sm02}
              value={data.birthyear}
              onChange={(e) => {
                handleChange(e, index);
              }}
              name="birthyear"
            />
            <div className={styles.date_text}>年</div>
            <input
              value={data.birthMonth}
              onChange={(e) => {
                handleChange(e, index);
              }}
              name="birthMonth"
              className={styles.input_sm02}
            />
            <div className={styles.date_text}>月</div>
            <input
              value={data.birthday}
              onChange={(e) => {
                handleChange(e, index);
              }}
              name="birthday"
              className={styles.input_sm02}
            />
            <div className={styles.date_text}>日</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SingleChildInfo;
